import enRoomNames from "./en-room-names.svg";
import geRoomNames from "./ge-room-names.svg";
import floorPlanDesignLogo from "./grundriss-mit-wasserzeichen.png";
import qm from "./qm.svg";

import blackBath from "./black-bath.svg";
import blackDimensionalChain from "./black-dimensional-chain.svg";
import blackDwg from "./black-dwg.svg";
import blackEntryPoint from "./black-entry-point.svg";
import blackFurniture from "./black-furniture.svg";
import blackKitchen from "./black-kitchen.svg";
import blackMap from "./black-map.svg";
import blackNorthArrow from "./black-north-arrow.svg";
import blackRoomNames from "./black-room-names.svg";
import blackScale from "./black-scale.svg";
import blackSquareMeters from "./black-square-meters.svg";
import blackDesign from "./grundriss-schwarz.svg";

import grayBath from "./gray-bath.svg";
import grayDimensionalChain from "./gray-dimensional-chain.svg";
import grayDwg from "./gray-dwg.svg";
import grayEntryPoint from "./gray-entry-point.svg";
import grayFurniture from "./gray-furniture.svg";
import grayKitchen from "./gray-kitchen.svg";
import grayMap from "./gray-map.svg";
import grayNorthArrow from "./gray-north-arrow.svg";
import grayRoomNames from "./gray-room-names.svg";
import grayScale from "./gray-scale.svg";
import graySquareMeters from "./gray-square-meters.svg";
import grayDesign from "./grundriss-grau.svg";

import modernDesign from "./grundriss-modern.svg";
import modernBath from "./modern-bath.svg";
import modernDimensionalChain from "./modern-dimensional-chain.svg";
import modernDwg from "./modern-dwg.svg";
import modernEntryPoint from "./modern-entry-point.svg";
import modernFurniture from "./modern-furniture.svg";
import modernKitchen from "./modern-kitchen.svg";
import modernMap from "./modern-map.svg";
import modernNorthArrow from "./modern-north-arrow.svg";
import modernRoomNames from "./modern-room-names.svg";
import modernScale from "./modern-scale.svg";
import modernSquareMeters from "./modern-square-meters.svg";

import whiteDesign from "./grundriss-schwarz-weiß.svg";
import whiteBath from "./white-bath.svg";
import whiteDimensionalChain from "./white-dimensional-chain.svg";
import whiteDwg from "./white-dwg.svg";
import whiteEntryPoint from "./white-entry-point.svg";
import whiteFurniture from "./white-furniture.svg";
import whiteKitchen from "./white-kitchen.svg";
import whiteMap from "./white-map.svg";
import whiteNorthArrow from "./white-north-arrow.svg";
import whiteRoomNames from "./white-room-names.svg";
import whiteScale from "./white-scale.svg";
import whiteSquareMeters from "./white-square-meters.svg";

import dimensionalArchitectStamp from "./order-process-configurator/dimensional/architect-stamp.svg";
import dimensionalBath from "./order-process-configurator/dimensional/bath.svg";
import dimensionalDwgIcon from "./order-process-configurator/dimensional/dwg-icon.svg";
import dimensionalFactsheetTableSmall from "./order-process-configurator/dimensional/factsheet-table-small.svg";
import dimensionalFactsheet from "./order-process-configurator/dimensional/factsheet.svg";
import dimensionalFloorPlan from "./order-process-configurator/dimensional/floor-plan.svg";
import dimensionalFurniture from "./order-process-configurator/dimensional/furniture.svg";
import dimensionalKitchen from "./order-process-configurator/dimensional/kitchen.svg";
import dimensionalWoflvIcon from "./order-process-configurator/dimensional/woflv-icon.svg";
import optimizedDimensionalChain from "./order-process-configurator/optimized/dimensional-chain.svg";
import optimizedDwgIcon from "./order-process-configurator/optimized/dwg-icon.svg";
import optimizedNorthArrowBlackWhite from "./order-process-configurator/optimized/north-arrow-black-white.svg";
import optimizedNorthArrowBlack from "./order-process-configurator/optimized/north-arrow-black.svg";
import optimizedNorthArrowGray from "./order-process-configurator/optimized/north-arrow-gray.svg";
import optimizedNorthArrowModern from "./order-process-configurator/optimized/north-arrow-modern.svg";
import optimizedScaleBlack from "./order-process-configurator/optimized/scale-black.svg";
import optimizedScaleGray from "./order-process-configurator/optimized/scale-gray.svg";
import optimizedScaleModern from "./order-process-configurator/optimized/scale-modern.svg";

export {
  blackBath,
  blackDesign,
  blackDimensionalChain,
  blackDwg,
  blackEntryPoint,
  blackFurniture,
  blackKitchen,
  blackMap,
  blackNorthArrow,
  blackRoomNames,
  blackScale,
  blackSquareMeters,
  dimensionalArchitectStamp,
  dimensionalBath,
  dimensionalDwgIcon,
  dimensionalFactsheet,
  dimensionalFactsheetTableSmall,
  dimensionalFloorPlan,
  dimensionalFurniture,
  dimensionalKitchen,
  dimensionalWoflvIcon,
  enRoomNames,
  floorPlanDesignLogo,
  geRoomNames,
  grayBath,
  grayDesign,
  grayDimensionalChain,
  grayDwg,
  grayEntryPoint,
  grayFurniture,
  grayKitchen,
  grayMap,
  grayNorthArrow,
  grayRoomNames,
  grayScale,
  graySquareMeters,
  modernBath,
  modernDesign,
  modernDimensionalChain,
  modernDwg,
  modernEntryPoint,
  modernFurniture,
  modernKitchen,
  modernMap,
  modernNorthArrow,
  modernRoomNames,
  modernScale,
  modernSquareMeters,
  optimizedDimensionalChain,
  optimizedDwgIcon,
  optimizedNorthArrowBlack,
  optimizedNorthArrowBlackWhite,
  optimizedNorthArrowGray,
  optimizedNorthArrowModern,
  optimizedScaleBlack,
  optimizedScaleGray,
  optimizedScaleModern,
  qm,
  whiteBath,
  whiteDesign,
  whiteDimensionalChain,
  whiteDwg,
  whiteEntryPoint,
  whiteFurniture,
  whiteKitchen,
  whiteMap,
  whiteNorthArrow,
  whiteRoomNames,
  whiteScale,
  whiteSquareMeters,
};
